export enum MetadataExtractionStatus {
  Failed,
  Extracted,
  Pending,
}
